// Tablo yapısı değiştirme için ek komponent ve modallar
import React from 'react';
import { FiColumns, FiKey, FiLink, FiEdit2, FiTrash2, FiX } from 'react-icons/fi';

// Add Column Modal Component
export const AddColumnModal = ({ show, onClose, onAdd, tableColumns, newColumn, setNewColumn }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FiColumns className="mr-3 text-purple-600" />
          Yeni Kolon Ekle
        </h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Kolon Adı</label>
            <input
              type="text"
              value={newColumn.columnName}
              onChange={(e) => setNewColumn({...newColumn, columnName: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="column_name"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Veri Tipi</label>
            <select
              value={newColumn.dataType}
              onChange={(e) => setNewColumn({...newColumn, dataType: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
            >
              <option value="INT">INT</option>
              <option value="VARCHAR">VARCHAR</option>
              <option value="TEXT">TEXT</option>
              <option value="DATETIME">DATETIME</option>
              <option value="DECIMAL">DECIMAL</option>
              <option value="BOOLEAN">BOOLEAN</option>
              <option value="BIGINT">BIGINT</option>
              <option value="FLOAT">FLOAT</option>
              <option value="DOUBLE">DOUBLE</option>
              <option value="DATE">DATE</option>
              <option value="TIME">TIME</option>
              <option value="TIMESTAMP">TIMESTAMP</option>
              <option value="JSON">JSON</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Uzunluk</label>
            <input
              type="text"
              value={newColumn.length}
              onChange={(e) => setNewColumn({...newColumn, length: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="255"
            />
          </div>
          
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={!newColumn.isNullable}
                onChange={(e) => setNewColumn({...newColumn, isNullable: !e.target.checked})}
                className="mr-2 rounded text-purple-600 focus:ring-purple-500"
              />
              <span className="text-sm font-medium text-gray-700">NOT NULL</span>
            </label>
            
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={newColumn.autoIncrement || false}
                onChange={(e) => {
                  setNewColumn({...newColumn, autoIncrement: e.target.checked});
                  // AUTO_INCREMENT seçilince otomatik NOT NULL yap
                  if (e.target.checked) {
                    setNewColumn({...newColumn, autoIncrement: true, isNullable: false});
                  }
                }}
                className="mr-2 rounded text-purple-600 focus:ring-purple-500"
                disabled={!['INT', 'BIGINT'].includes(newColumn.dataType)}
              />
              <span className={`text-sm font-medium ${['INT', 'BIGINT'].includes(newColumn.dataType) ? 'text-gray-700' : 'text-gray-400'}`}>
                AUTO INCREMENT
              </span>
              {newColumn.autoIncrement && (
                <span className="ml-2 text-xs text-purple-600">(PRIMARY KEY eklenecek)</span>
              )}
            </label>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Varsayılan Değer</label>
            <input
              type="text"
              value={newColumn.defaultValue}
              onChange={(e) => setNewColumn({...newColumn, defaultValue: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="NULL"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Sonrasına Ekle</label>
            <select
              value={newColumn.after}
              onChange={(e) => setNewColumn({...newColumn, after: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
            >
              <option value="">En Sona</option>
              {tableColumns.map(col => (
                <option key={col.column_name} value={col.column_name}>{col.column_name}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            İptal
          </button>
          <button
            onClick={onAdd}
            className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          >
            Kolon Ekle
          </button>
        </div>
      </div>
    </div>
  );
};

// Edit Column Modal Component
export const EditColumnModal = ({ show, onClose, onEdit, editingColumn, editColumn, setEditColumn }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FiEdit2 className="mr-3 text-blue-600" />
          Kolon Düzenle: {editingColumn}
        </h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Yeni Kolon Adı</label>
            <input
              type="text"
              value={editColumn.newName}
              onChange={(e) => setEditColumn({...editColumn, newName: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Veri Tipi</label>
            <select
              value={editColumn.dataType}
              onChange={(e) => setEditColumn({...editColumn, dataType: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="INT">INT</option>
              <option value="VARCHAR">VARCHAR</option>
              <option value="TEXT">TEXT</option>
              <option value="DATETIME">DATETIME</option>
              <option value="DECIMAL">DECIMAL</option>
              <option value="BOOLEAN">BOOLEAN</option>
              <option value="BIGINT">BIGINT</option>
              <option value="FLOAT">FLOAT</option>
              <option value="DOUBLE">DOUBLE</option>
              <option value="DATE">DATE</option>
              <option value="TIME">TIME</option>
              <option value="TIMESTAMP">TIMESTAMP</option>
              <option value="JSON">JSON</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Uzunluk</label>
            <input
              type="text"
              value={editColumn.length}
              onChange={(e) => setEditColumn({...editColumn, length: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="255"
            />
          </div>
          
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={!editColumn.isNullable}
                onChange={(e) => setEditColumn({...editColumn, isNullable: !e.target.checked})}
                className="mr-2 rounded text-blue-600 focus:ring-blue-500"
              />
              <span className="text-sm font-medium text-gray-700">NOT NULL</span>
            </label>
            
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={editColumn.autoIncrement || false}
                onChange={(e) => setEditColumn({...editColumn, autoIncrement: e.target.checked})}
                className="mr-2 rounded text-blue-600 focus:ring-blue-500"
                disabled={!['INT', 'BIGINT'].includes(editColumn.dataType)}
              />
              <span className={`text-sm font-medium ${['INT', 'BIGINT'].includes(editColumn.dataType) ? 'text-gray-700' : 'text-gray-400'}`}>
                AUTO INCREMENT
              </span>
            </label>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Varsayılan Değer</label>
            <input
              type="text"
              value={editColumn.defaultValue}
              onChange={(e) => setEditColumn({...editColumn, defaultValue: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="NULL"
            />
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            İptal
          </button>
          <button
            onClick={onEdit}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Güncelle
          </button>
        </div>
      </div>
    </div>
  );
};

// Add Index Modal Component
export const AddIndexModal = ({ show, onClose, onAdd, tableColumns, newIndex, setNewIndex }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FiKey className="mr-3 text-blue-600" />
          Yeni İndeks Ekle
        </h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">İndeks Adı</label>
            <input
              type="text"
              value={newIndex.indexName}
              onChange={(e) => setNewIndex({...newIndex, indexName: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="idx_column_name"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">İndeks Tipi</label>
            <select
              value={newIndex.indexType}
              onChange={(e) => setNewIndex({...newIndex, indexType: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="INDEX">INDEX</option>
              <option value="UNIQUE">UNIQUE</option>
              <option value="FULLTEXT">FULLTEXT</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Kolonlar</label>
            <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3">
              {tableColumns.map(col => (
                <label key={col.column_name} className="flex items-center hover:bg-gray-50 p-1 rounded">
                  <input
                    type="checkbox"
                    value={col.column_name}
                    checked={newIndex.columns.includes(col.column_name)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setNewIndex({...newIndex, columns: [...newIndex.columns, col.column_name]});
                      } else {
                        setNewIndex({...newIndex, columns: newIndex.columns.filter(c => c !== col.column_name)});
                      }
                    }}
                    className="mr-2 rounded text-blue-600 focus:ring-blue-500"
                  />
                  <span className="text-sm text-gray-700">{col.column_name}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            İptal
          </button>
          <button
            onClick={onAdd}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            İndeks Ekle
          </button>
        </div>
      </div>
    </div>
  );
};

// Add Foreign Key Modal Component
export const AddForeignKeyModal = ({ show, onClose, onAdd, tableColumns, tables, newForeignKey, setNewForeignKey }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FiLink className="mr-3 text-green-600" />
          Foreign Key Ekle
        </h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Constraint Adı</label>
            <input
              type="text"
              value={newForeignKey.constraintName}
              onChange={(e) => setNewForeignKey({...newForeignKey, constraintName: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              placeholder="fk_table_column"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Kolon</label>
            <select
              value={newForeignKey.columnName}
              onChange={(e) => setNewForeignKey({...newForeignKey, columnName: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            >
              <option value="">Seçin</option>
              {tableColumns.map(col => (
                <option key={col.column_name} value={col.column_name}>{col.column_name}</option>
              ))}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Referans Tablo</label>
            <select
              value={newForeignKey.referencedTable}
              onChange={(e) => setNewForeignKey({...newForeignKey, referencedTable: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            >
              <option value="">Seçin</option>
              {tables && tables.map(table => (
                <option key={table.table_name} value={table.table_name}>{table.table_name}</option>
              ))}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Referans Kolon</label>
            <input
              type="text"
              value={newForeignKey.referencedColumn}
              onChange={(e) => setNewForeignKey({...newForeignKey, referencedColumn: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              placeholder="id"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">ON DELETE</label>
              <select
                value={newForeignKey.onDelete}
                onChange={(e) => setNewForeignKey({...newForeignKey, onDelete: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              >
                <option value="RESTRICT">RESTRICT</option>
                <option value="CASCADE">CASCADE</option>
                <option value="SET NULL">SET NULL</option>
                <option value="NO ACTION">NO ACTION</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">ON UPDATE</label>
              <select
                value={newForeignKey.onUpdate}
                onChange={(e) => setNewForeignKey({...newForeignKey, onUpdate: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              >
                <option value="RESTRICT">RESTRICT</option>
                <option value="CASCADE">CASCADE</option>
                <option value="SET NULL">SET NULL</option>
                <option value="NO ACTION">NO ACTION</option>
              </select>
            </div>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            İptal
          </button>
          <button
            onClick={onAdd}
            className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            Foreign Key Ekle
          </button>
        </div>
      </div>
    </div>
  );
};

// Table Structure Actions Component
export const TableStructureActions = ({ onAddColumn, onAddIndex, onAddForeignKey }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <button
        onClick={onAddColumn}
        className="bg-white border-2 border-purple-200 rounded-xl p-6 hover:border-purple-400 hover:shadow-lg transition-all group"
      >
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center group-hover:bg-purple-200 transition-colors">
            <FiColumns className="text-purple-600 text-xl" />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-gray-800">Kolon Ekle</h3>
            <p className="text-sm text-gray-600">Yeni kolon ekle</p>
          </div>
        </div>
      </button>

      <button
        onClick={onAddIndex}
        className="bg-white border-2 border-blue-200 rounded-xl p-6 hover:border-blue-400 hover:shadow-lg transition-all group"
      >
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-blue-200 transition-colors">
            <FiKey className="text-blue-600 text-xl" />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-gray-800">İndeks Ekle</h3>
            <p className="text-sm text-gray-600">Yeni indeks oluştur</p>
          </div>
        </div>
      </button>

      <button
        onClick={onAddForeignKey}
        className="bg-white border-2 border-green-200 rounded-xl p-6 hover:border-green-400 hover:shadow-lg transition-all group"
      >
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center group-hover:bg-green-200 transition-colors">
            <FiLink className="text-green-600 text-xl" />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-gray-800">Foreign Key</h3>
            <p className="text-sm text-gray-600">İlişki tanımla</p>
          </div>
        </div>
      </button>
    </div>
  );
};